import { defineComponent, openBlock, createElementBlock, createElementVNode } from 'vue';
import _export_sfc from './_virtual/plugin-vue_export-helper.mjs';

const _sfc_main = defineComponent({
  name: "Guanxiwangtongzhi"
});
const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2 = /* @__PURE__ */ createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M7.03677 3.71065C7.03677 4.03342 6.96774 4.34003 6.84366 4.61646L9.59588 6.82287C10.4939 5.92426 11.7337 5.36857 13.103 5.36857C15.8441 5.36857 18.0662 7.59537 18.0662 10.3423C18.0662 11.5943 17.6046 12.7382 16.8426 13.6125L18.5214 15.4478C18.7203 15.3629 18.9393 15.3159 19.1691 15.3159C20.0829 15.3159 20.8236 16.0582 20.8236 16.9738C20.8236 17.8894 20.0829 18.6317 19.1691 18.6317C18.2554 18.6317 17.5147 17.8894 17.5147 16.9738C17.5147 16.6922 17.5848 16.427 17.7084 16.1948L16.0297 14.3596C15.2091 14.961 14.1974 15.3159 13.103 15.3159C10.3618 15.3159 8.13973 13.0892 8.13973 10.3423C8.13973 9.3653 8.42081 8.45412 8.90636 7.68552L6.15435 5.47928C5.78569 5.75676 5.32745 5.92118 4.83088 5.92118C3.61261 5.92118 2.625 4.93149 2.625 3.71065C2.625 2.48981 3.61261 1.50012 4.83088 1.50012C6.04916 1.50012 7.03677 2.48981 7.03677 3.71065Z",
  fill: "#BDC3CD"
}, null, -1);
const _hoisted_3 = /* @__PURE__ */ createElementVNode("path", {
  opacity: "0.6",
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M19.1692 5.92118C20.3875 5.92118 21.3751 4.9315 21.3751 3.71065C21.3751 2.48981 20.3875 1.50012 19.1692 1.50012C17.9509 1.50012 16.9633 2.48981 16.9633 3.71065C16.9633 4.15496 17.0941 4.56864 17.3193 4.91515L16.0297 6.32491C16.3276 6.5432 16.6002 6.79395 16.8425 7.07196L18.1322 5.66216C18.4413 5.82747 18.7943 5.92118 19.1692 5.92118ZM9.66858 13.9329C9.93397 14.1879 10.2276 14.4136 10.5442 14.6049L8.01302 17.9219C8.4354 18.4074 8.69122 19.0422 8.69122 19.7369C8.69122 21.263 7.45671 22.5001 5.93387 22.5001C4.41102 22.5001 3.17651 21.263 3.17651 19.7369C3.17651 18.2109 4.41102 16.9738 5.93387 16.9738C6.36531 16.9738 6.7736 17.0731 7.13723 17.2501L9.66858 13.9329Z",
  fill: "#BDC3CD"
}, null, -1);
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _hoisted_4);
}
var guanxiwangtongzhi = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render]]);

export { guanxiwangtongzhi as default };
